import axios from 'axios';

class LogService {
    log(from, to) {
        return axios.post('auth/admin/log', {from: from, to: to});
    }
}
export default new LogService();

